import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class DividedBlogSection extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
      richTextResolver: item => `<object cite="${item.cite}" 
                                         image="${item.image}"
                                         order="${item.order}" 
                                         constructor="${
  item.type
}"/>`,
    });
  }

  get type() {
    return get(this, 'system.type', '');
  }

  get cite() {
    return get(this, '_cite.value', '');
  }

  get order() {
    return get(this, '_order.value[0].name', '');
  }

  get image() {
    return get(this, '_image.value[0].url', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/DividedBlogSection.model.js